import { IOktaMFAFactorProfileKey } from "./IOktaMFAFactorProfileKey";

export interface IOktaMFAFactorProfile {
  credentialId: string;
  deviceType: string;
  keys: IOktaMFAFactorProfileKey[];
  name: string;
  platform: string;
  version: string;
}
